import React from 'react';
import { Button, Col, Container, Image, Row, Table } from 'react-bootstrap';
import { NavBarComponente } from '../../Components/NavBarComponente';
import fechar from '../../Imagens/close-24.png';
import { StreetViewViewModel } from './StreetViewViewModel';

import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";
import "../../Estilo/Form.css";
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';

import voltar from '../../Imagens/arrow-left-16.png';
import voltarInicio from '../../Imagens/arrow-left-first-16.png';
import proximo from '../../Imagens/arrow-right-16.png';
import proximoUltimo from '../../Imagens/arrow-right-last-16.png';
import editar from '../../Imagens/edit-16.png';
import importar from '../../Imagens/import.svg';
import moment from 'moment';
import { TypePagination } from '../TableGeneric/TableGenericViewController';

interface MyProps {
    navigation: any
    delegate: StreetViewViewControllerDelegate
    viewModel: StreetViewViewModel
}

export interface StreetViewViewControllerDelegate {
    tapDimiss(navigation: any): void
}

export class StreetViewViewController extends React.Component<MyProps> {
    private fileInput: HTMLInputElement | null = null;
    private formEvent: FormEvent
    state = {
        page: 1,
        countPage: 0,
        countLine: 0,
        isLoading: false,
        json: {},
        result: []
    }

    constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
    }

    componentDidMount() {
        this.loadStruct(this.state.page)
    }

    render() {
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation} />
                <div>
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Importar Imagens Street View</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                        onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                        src={fechar} />
                                </div>
                            </Col>
                        </Row>

                        <Row className="header">
                            <Col xs="12" className="containerActions">
                                <input
                                    type="file"
                                    ref={(ref) => (this.fileInput = ref)}
                                    style={{ display: 'none' }}
                                    onChange={this.handleFileChange}
                                    multiple={false}
                                    accept='.zip'
                                />
                                <Button
                                    variant="info"
                                    type="button"
                                    className="buttonGeneric colorGeneric"
                                    onClick={() => this.importImage()}
                                >
                                    <Image className="iconButtonGeneric" src={importar} />
                                    Importar
                                </Button>

                            </Col>
                        </Row>
                    </Container>
                    <div className="tableData">
                        <Table responsive={true}>
                            <thead className="tableDataHead">
                                <tr>
                                    <th>ID</th>
                                    <th>Nome Arquivo</th>
                                    <th>Data</th>
                                    <th>Status</th>
                                </tr>

                            </thead>
                            <tbody className="tableDataBody">
                                {this.state.result.map((item: any) => (
                                    <tr>
                                        <td>{item.sgepimagem360lote}</td>
                                        <td>{item.nome} </td>
                                        <td>{moment(item.data).format('HH:mm:ss DD/MM/YYYY')}</td>
                                        <td>{this.statusConverter(item.status)} </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                    <div className="tableContainerNav">
                        <Container fluid={true}>
                            <Row>
                                <Col xs="12">
                                    <div style={{ height: 30 }}>
                                        <div style={{ float: "right" }}>
                                            <label className="tableCountData">Número de Registros: {this.state.countLine}</label>
                                        </div>
                                        <div style={{ float: "left" }}>
                                            <Image
                                                onClick={() => this.pagination('first')}
                                                style={{ marginLeft: 0, cursor: "pointer" }}
                                                src={voltarInicio}
                                                width={16}
                                                className="center"
                                                fluid />
                                            <Image
                                                onClick={() => this.pagination('back')}
                                                src={voltar}
                                                className="center imageNav"
                                                fluid />
                                            <label className="tablePage">{this.state.page}/{this.state.countPage}</label>
                                            <Image
                                                onClick={() => this.pagination('next')}
                                                src={proximo}
                                                className="center imageNav"
                                                fluid />
                                            <Image
                                                onClick={() => this.pagination('last')}
                                                src={proximoUltimo}
                                                className="center imageNav"
                                                fluid />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <ToastContainer />
                </div >
                <LoaderComponente show={this.state.isLoading} hide={() => this.setState({ isLoading: this.state.isLoading })} />
            </div>
        )
    }

    private importImage() {
        if (this.fileInput) {
            this.fileInput.click();
        }
    }

    private handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        if (!file.name.toLowerCase().endsWith('.zip')) {
            toast.error('Apenas arquivos .zip são permitidos');
            event.target.value = '';
            return;
        }

        const formData = new FormData()
        formData.append('file', file);
        this.setState({ isLoading: true })
        try {
            await this.props.viewModel.fetchImport(formData);
        } catch (error) {
            toast.error('Erro ao importar arquivo');
            console.error(error);
        } finally {
            this.setState({ isLoading: false })
            this.loadStruct(this.state.page);
        }
    };



    private statusConverter(status: string) {
        var statusReturn
        switch (status) {
            case 'ERROR':
                statusReturn = 'Erro'
                break;
            case 'PROCESSING':
                statusReturn = 'Processando'
                break;
            case 'SUCCESS':
                statusReturn = 'Sucesso'
                break;
            default:
                statusReturn = 'Sem status'
                break;
        }
        return statusReturn

    }
    private loadStruct(page: number) {

        this.setState({ isLoading: true })
        this.props.viewModel.fetchData(page).then((rs) => {
            var resultado = rs.resultado
            this.setState({
                result: resultado,
                isLoading: false,
                countLine: rs.count,
                countPage: rs.count > 0 ? Math.ceil(rs.count / 10) : 1
            })
            return

        }, e => {
            console.log('erro', e)
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }

    private pagination(type: TypePagination) {

        var page = 0
        switch (type) {
            case 'first':
                page = 1
                break;
            case 'back':
                page = this.state.page == 1 ? 1 : this.state.page - 1
                break;
            case 'next':
                page = this.state.page == this.state.countPage ? this.state.countPage : this.state.page + 1
                break;
            case 'last':
                page = this.state.countPage
                break;
        }

        this.setState({
            page: page
        })

        this.loadStruct(page)
    }
}
